import apiClient from './api.client';

const mirandaConfig = { skipGlobalLoading: true };

const MirandaService = {
  getStatus: async (accountId) => {
    const res = await apiClient.get('/miranda/status', {
      ...mirandaConfig,
      params: { accountId },
    });
    return res.data;
  },

  getUsage: async (accountId) => {
    const res = await apiClient.get('/miranda/usage', {
      ...mirandaConfig,
      params: { accountId },
    });
    return res.data;
  },

  chat: async (accountId, message, { history = [], conversationId } = {}) => {
    const res = await apiClient.post(
      '/miranda/chat',
      {
        message,
        history,
        ...(conversationId ? { conversationId } : {}),
      },
      { ...mirandaConfig, params: { accountId } },
    );
    return res.data;
  },

  listConversations: async (accountId) => {
    const res = await apiClient.get('/miranda/conversations', {
      ...mirandaConfig,
      params: { accountId },
    });
    return res.data;
  },

  getConversation: async (accountId, id) => {
    const res = await apiClient.get(`/miranda/conversations/${id}`, {
      ...mirandaConfig,
      params: { accountId },
    });
    return res.data;
  },

  listReports: async (accountId) => {
    const res = await apiClient.get('/miranda/reports', {
      ...mirandaConfig,
      params: { accountId },
    });
    return res.data;
  },

  getReport: async (accountId, id) => {
    const res = await apiClient.get(`/miranda/reports/${id}`, {
      ...mirandaConfig,
      params: { accountId },
    });
    return res.data;
  },

  generateReport: async (accountId, daysAgo = 1) => {
    const res = await apiClient.post(
      '/miranda/reports/generate',
      null,
      { ...mirandaConfig, params: { accountId, daysAgo } },
    );
    return res.data;
  },
};

export default MirandaService;
